// extracted by mini-css-extract-plugin
export default {"description":"style_description__JvJiW","body":"style_body__FtVnX","mask":"style_mask__Av9io","description2":"style_description2__Vx2HH","mask2":"style_mask2__Nuzpx"};